export const projects = [
  {
    title: "Neuro-Rehabilitation Software Tool Using Machine Learning",
    subtitle: "Electron, Python, SQL",
    description:
      "Desktop application for health care professionals to input long egocentric videos and specify hand-object interactions that they want to see.",
    image: "./patient.jpg",
    link: "",
  },
  {
    title: "Speech Recognition for Accented Speech",
    subtitle: "Python, Pytorch",
    description:
      "This project aims to develop a simple speech-to-Text recognition system that accurately transcribes spoken words while accommodating various accents and dialects.",
    image: "./speech.png",
    link: "https://github.com/Sagarika2870/speech-recognition",
  },
  {
    title: "GIS Mapping Software",
    subtitle: "C++, EZGL and GTK",
    description:
      "Mapping application that can find the shortest path between two intersections",
    image: "./mapper.jpg",
    link: "https://github.com/Sagarika2870/GIS-Mapping",
  },
  {
    title: "Seam Carving",
    subtitle: "C",
    description:
      "Image resizing technique that enlarges or shrinks images pixel-by-pixel",
    image: "./Seam-carving.gif",
    link: "https://github.com/Sagarika2870/Seam-Carving",
  },
];



export const skills = [
  "Python",
  "Java/Kotlin",
  "C",
  "C++",
  "Javascript",
  "React ",
  "HTML",
  "CSS",
  "Git",
];

export const data = "Since I am still early on in my learning journey, I have taken many opportunities to get exposure to ";
